import React from 'react';
import type { QuickAccessItem } from '../types';

interface Props {
  items: QuickAccessItem[];
  onOpenPreview: (fileId: string) => void;
  onDownload: (fileId: string) => void;
}

export const QuickAccessSection: React.FC<Props> = ({
  items,
  onOpenPreview,
  onDownload,
}) => {
  const getBadgeClass = (mime: string, name: string) => {
    if (mime.includes('pdf') || name.endsWith('.pdf')) return 'badge-pdf';
    if (mime.includes('spreadsheet') || mime.includes('excel') || name.endsWith('.xlsx')) {
      return 'badge-xlsx';
    }
    return 'badge-docx';
  };

  const getFormatLabel = (mime: string, name: string) => {
    if (mime.includes('pdf') || name.endsWith('.pdf')) return 'PDF';
    if (mime.includes('spreadsheet') || mime.includes('excel') || name.endsWith('.xlsx')) {
      return 'XLSX';
    }
    return 'DOCX';
  };

  return (
    <section className="quick-access-section" aria-label="Быстрый доступ">
      <div className="quick-access-head">
        <h2>Быстрый доступ</h2>
        <p>Ключевые исходные файлы открываются во встроенном просмотрщике.</p>
      </div>

      <div className="quick-access-grid">
        {items.map((item) => {
          const badgeClass = getBadgeClass(item.mime_type, item.original_name);
          const formatLabel = getFormatLabel(item.mime_type, item.original_name);

          return (
            <div key={item.id} className="quick-access-card" data-testid={`qa-card-${item.file_id}`}>
              <div className="qa-card-left">
                <span className={`qa-badge ${badgeClass}`}>{formatLabel}</span>
                <div className="qa-info">
                  <h3 className="qa-title" title={item.display_name}>
                    {item.display_name}
                  </h3>
                  <div className="qa-meta">
                    {item.quick_access_subtitle && (
                      <span className="qa-subtitle">{item.quick_access_subtitle}</span>
                    )}
                    <span className="qa-version-pill">{item.current_version_no}</span>
                    {item.is_current && <span className="qa-current-pill">Актуальная</span>}
                  </div>
                </div>
              </div>

              <div className="qa-actions">
                <button
                  type="button"
                  className="btn-open-preview"
                  onClick={() => onOpenPreview(item.file_id)}
                >
                  Открыть / Посмотреть
                </button>
                <button
                  type="button"
                  className="btn-download-action"
                  onClick={() => onDownload(item.file_id)}
                >
                  Скачать
                </button>
              </div>
            </div>
          );
        })}
      </div>
    </section>
  );
};
